import { render, staticRenderFns } from "./points.vue?vue&type=template&id=43da5520"
import script from "./points.vue?vue&type=script&lang=js"
export * from "./points.vue?vue&type=script&lang=js"
import style0 from "./points.vue?vue&type=style&index=0&id=43da5520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports